import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle";
import Main from "./Compunents/Main_page/Main";
import PreLoader from "./Compunents/PreLoader";

function App() {
  return (
    <>
      <Main />
      <PreLoader />
    </>
  );
}

export default App;
